import { isNullOrUndefined } from 'src/app/shared/TerraUtils';
import { OrderDirectionType, SortUiState } from './SortUiState.model';

export class DocumentsUiState {
  private static ORDER_BY_DEFAULT = 'DisplayName';
  private static DIRECTION_DEFAULT: OrderDirectionType = 'asc';

  public sort: SortUiState;
  public skipPrepareStep: boolean;

  constructor() {
    this.sort = {
      orderBy: DocumentsUiState.ORDER_BY_DEFAULT,
      direction: DocumentsUiState.DIRECTION_DEFAULT,
    };
    this.skipPrepareStep = false;
  }

  static fromJson(documentsObj: any): DocumentsUiState {
    const model = new DocumentsUiState();
    if (documentsObj && documentsObj.sort) {
      model.sort = {
        orderBy: documentsObj.sort.orderBy || DocumentsUiState.ORDER_BY_DEFAULT,
        direction:
          documentsObj.sort.direction || DocumentsUiState.DIRECTION_DEFAULT,
      };
    }

    model.skipPrepareStep = !isNullOrUndefined(documentsObj?.skipPrepareStep)
      ? documentsObj.skipPrepareStep
      : false;

    return model;
  }
}
